import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
import Cookie from 'js-cookie';
import store from '@/store';
import menu from './menu';

// Lazy load:
// https://router.vuejs.org/zh-cn/advanced/lazy-loading.html

const Home = () => import('@/containers/Home/Home.vue');
const User = () => import('@/views/User/User.vue');
const Login = () => import('@/views/Login/Login.vue');
const Guide = () => import('@/views/Guide/Guide.vue');
const NotFound = () => import('@/views/NotFound/NotFound.vue');
const Password = () => import('@/views/Password/Password.vue');
const ChangePwd = () => import('@/views/Password/ChangePwd.vue');
const PhoneValidate = () => import('@/views/PhoneValidate/PhoneValidate.vue');
const Health = () => import('@/views/Health/Health.vue');

const authRouter = [];
const keepAlives = [];//缓存组件列表

Object.keys(menu).forEach(module =>
  Object.keys(menu[module].pages).forEach((page) => {
    const { label, path, component, keepAlive } = menu[module].pages[page];

    if(keepAlive) {
      keepAlives.push(page);
    }

    authRouter.push({
      name: page,
      path,
      component,
      meta: {
        requiresAuth: true,
        docTitle: `权限控制系统-${label}`,
      },
    });
  }),
);


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/password',
      name: 'password',
      component: Password,
      meta: {
        docTitle: '重置密码',
      },
    },
    {
      path: '/changepwd',
      name: 'changePwd',
      component: ChangePwd,
      meta: {
        docTitle: '修改密码',
      },
    },
    {
      path: '/phonevalidate',
      name: 'phonevalidate',
      component: PhoneValidate,
      meta: {
        docTitle: '兼职账号安全验证',
      },
    },
    {
      path: '/health',
      name: 'health',
      component: Health,
      meta: {
        docTitle: '健康检测',
      },
    },
    {
      path: '/user',
      component: User,
      children: [
        {
          path: '',
          redirect: '/user/home',
        },
        {
          name: 'home',
          path: 'home',
          component: Home,
          meta: {
            requiresAuth: true,
            docTitle: '权限控制系统-主页',
          },
        },
        ...authRouter,
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        docTitle: '欢迎登录综合管理平台',
      },
    },
    {
      path: '/guide',
      name: 'guide',
      component: Guide,
      meta: {
        requiresAuth: true,
        docTitle: '综合管理平台导航',
      },
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
      meta: {
        docTitle: '404',
      },
    },
  ],
});

function checkRouter(to, from, next) {
  if (
    to.name === 'guide' ||
    to.name === 'home' ||
    store.state.auth.validPage.indexOf(to.name) > -1
  ) {
    return next();
  }

  if (from.name) {
    Message({
      message: '您暂无权限进入该页面',
      duration: 3,
      type: 'error'
    });
    return next(false);
  }
  Message({
    message: '您暂无权限进入该页面, 已返回系统主页',
    duration: 3,
    type: 'error'
  });
  return next({
    name: 'home',
  });
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = Cookie.get('token');
    const userId = Cookie.get('userId');
    const userName = Cookie.get('userName');
    if (token && userId && userName) {
      if (store.state.auth.userName === 'admin' || to.name === 'guide') {
        return next();
      }
      if (store.state.auth.validMenu.loaded && store.state.auth.systems.loaded) {
        return checkRouter(to, from, next);
      }

      store.dispatch('auth/LOAD_CITYLIST', {
        frontCode: 'NOT',
        params:{
          sysCode:'izk-authservice'
        }
      }).then(()=>{
          const loads = [];
          if (!store.state.auth.validMenu.loaded) {
            loads.push(store.dispatch('auth/LOAD_MENULIST', {
              frontCode: 'NOT',
            }));
          }
          if (!store.state.auth.systems.loaded) {
            loads.push(store.dispatch('auth/LOAD_SYSTEMS', {
              frontCode: 'NOT',
            }));
          }
          return Promise.all(loads).then(() => checkRouter(to, from, next)).catch(() => false);
      });

    }else{
      return next({
        name: 'login',
        query: { target: encodeURIComponent(window.location.href) },
      });
    }
  }else{
    return next();
  }
});

router.afterEach((route) => {
  // 改变Title:
  document.title = route.matched[route.matched.length - 1].meta.docTitle;
});

export default router;
export { keepAlives }



// WEBPACK FOOTER //
// ./src/router/index.js